/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentTitleRequestObject = {
    properties: {
        title: {
    type: 'string',
    isRequired: true,
},
    },
};